import { Routes } from '@angular/router';
import { Dashboard } from './dashboard/dashboard';
import { AuthGuard } from '@divezone/core';
import { hasCustomClaim } from '@angular/fire/auth-guard';

const superAdminOnly = () => hasCustomClaim('superAdmin');

export const routes: Routes = [
  { path: '', component: Dashboard, canActivate: [AuthGuard, superAdminOnly] },
  { path: '*', redirectTo: '' }
];
